module.exports = __webpack_public_path__ + "b2510d88985b49b86fa3f4bfed2f51d7.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lankenau03.jpg
// module id = 659
// module chunks = 0